import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { createRef, useState, useEffect, useLayoutEffect, useCallback, useRef } from 'react';
import { Button, ButtonGroup } from 'react-bootstrap';
import _, { findIndex as _findIndex, forEach as _forEach, cloneDeep as _cloneDeep, find as _find } from 'lodash';
import { Tooltip } from 'react-tooltip';
import { confirmAlert } from 'js/wrapper/CustomConfirmAlert';
import withRouter from 'js/withRouter';
import { legacyInjectIntl } from 'js/wrapper/injectIntl';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import FormInput from 'components/forms/FormInput';
import { DndContext, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { DraggableWrapper } from './DraggableWrapper';
import PreviewBlockFTs from './PreviewBlockFTs';
import EditorBlockFTs from './EditorBlockFTs';
import { getBlockTopFromRaster, getRasterSlots, getSiblings } from './actions/Raster';
import EditorApplyStylesFTs from './EditorApplyStylesFTs';
import { getPageNameIndex } from './actions/TemplateSettings';
import Loader from '../../components/layout/Loader';
import Pagination from '../../components/layout/Pagination';
import FormAutocomplete from '../../components/forms/FormAutocomplete';
function ContextModal({ children }) {
    const modalRoot = document.getElementById('context-modal');
    if (!modalRoot) {
        return null;
    }
    return ReactDOM.createPortal(children, modalRoot);
}
/**
 * Extracts attribute value from a HTML code string
 */
const getNumericValue = (str, attributeName) => {
    const re = new RegExp(`${attributeName}="\\s*([^"\\s]*)`);
    const match = re.exec(str);
    return match ? Number(match[1]) : 0;
};
/**
 * Extracts attribute value from a HTML code string
 */
const getAttributeValue = (str, attributeName) => {
    const re = new RegExp(`${attributeName}\\(([^)]+)\\)`);
    const match = re.exec(str);
    return match ? match[1] : null;
};
const EditorPage = (props) => {
    var _a, _b;
    const { blocks: propsBlocks, updateBlock, setActiveHeight, type, goToLastPageState, goToLastPage, resetPageState, resetPage, settings, currentPage, pagesCount, updateBlocksState, resetStates, changeBlock, removeContentBlock, resetBlock, pasteBlock, copyBlock, resizeBlock, updateCurrentPage, updateSpecialBlockAttributes, imageUpload, raster, usedMedia, trimBorderActive, grid, index, updateParam, updateInnerBlock, pageZoom, stageWidth, pasteData, copiedBlock, changeErrors, templateBlocks, appIntl, blockContainer, setBlockContainer, unsetBlockContainer, website, resetNavEntry, navEntry, pageHeight, pageWidth, marginWidth, evenOdd, paddingBottom, paddingTop, publisherInfo, rootUser, wlAdminUser, isSubmission, onlyWhitelabelAdminCanModifyBlocks, filesUploading, saveDescription, uploadError, showKeyboard, colorSettings, fontSizeSettings, updatePageSize, initDefaultPosition, allUsedBlocks, allUsedBlocksContent, setSelectedColor, getColorSettings, deleteSelectedColor, setFontSizeSettings, getDeviceType, fitAuto, setSelectedObjectForAI, selectedObjectForAI } = props;
    const pageRef = createRef();
    const sectionRef = createRef();
    const hideLoadingTimeoutRef = useRef(undefined);
    const messages = (_a = appIntl === null || appIntl === void 0 ? void 0 : appIntl.messages) === null || _a === void 0 ? void 0 : _a.messages;
    const [blocks, setBlocks] = useState([]);
    const [bgColor, setBgColor] = useState({});
    const [blocksPerPage] = useState(4);
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [allPages, setAllPages] = useState(Math.ceil(propsBlocks.length / 4));
    const [deltaPosition, setDeltaPosition] = useState([]);
    const [showFilter, setShowFilter] = useState(false);
    const [blockForFilter, setBlockForFilter] = useState(null);
    const [filter, setFilterState] = useState({
        grayscale: 0,
        sepia: 0,
        blur: 0,
        brightness: 1,
        contrast: 1,
        shadow: 0,
        rotate: 0,
        invert: 0,
        opacity: 1,
        saturate: 1,
    });
    const [filterAsString, setFilterAsString] = useState('');
    const [showUrl, setShowUrl] = useState(false);
    const [imgUrl, setImgUrl] = useState('');
    const [blockForUrl, setBlockForUrl] = useState();
    const [inputRange, setInputRange] = useState({
        htmlFor: '',
        id: '',
        name: '',
        min: 0,
        max: 1,
        step: 0.1,
        defaultValue: '',
        message: '',
    });
    const [outputRange, setOutputRange] = useState([]);
    const [currentFilterData, setCurrentFilterData] = useState('');
    const [blockImages, setBlockImages] = useState([]);
    const [indexOfImage, setIndexOfImage] = useState(0);
    const [isPageInitialized, setIsPageInitialized] = useState(false);
    const _isMounted = useRef(true);
    const sensors = useSensors(useSensor(PointerSensor, {
        activationConstraint: {
            distance: 3, // Starts only after the mouse has moved 3 pixels.
        },
    }));
    const handleDragEnd = useCallback((event) => {
        var _a, _b;
        const { active } = event;
        const id = active.id;
        const data = _cloneDeep(propsBlocks);
        const block = _find(data, {
            id,
        });
        if (!block) {
            return;
        }
        const offset = dragOffsets.current[id];
        if (!offset) {
            return;
        }
        block.position_x = ((_a = block.position_x) !== null && _a !== void 0 ? _a : 0) + offset.x;
        block.position_y = ((_b = block.position_y) !== null && _b !== void 0 ? _b : 0) + offset.y;
        updateBlock(id, data, true);
    }, [propsBlocks, updateBlock]);
    // Initialize delta positions
    const initializeDeltaPositions = useCallback(() => {
        const _deltaPosition = _cloneDeep(deltaPosition);
        _forEach(propsBlocks, (block) => {
            let blockTemplate = _cloneDeep(block.template);
            blockTemplate = blockTemplate.toLowerCase();
            const index = _.findIndex(deltaPosition, (data) => data.blockId === block.id);
            if (index === -1) {
                let posX = getNumericValue(blockTemplate, 'defaultpositionx') || 0;
                let posY = getNumericValue(blockTemplate, 'defaultpositiony') || 0;
                if (block.position_x) {
                    posX = block.position_x;
                }
                if (block.position_y) {
                    posY = block.position_y;
                }
                const positions = {
                    blockId: block.id,
                    x: posX,
                    y: posY,
                };
                _deltaPosition.push(positions);
            }
        });
        setDeltaPosition(_deltaPosition);
    }, [propsBlocks, deltaPosition]);
    const dragOffsets = useRef({});
    // Change page for endless mode
    const changePage = useCallback((selectedPage) => {
        let blocksPaginated = [];
        blocksPaginated = propsBlocks.filter((i, index) => index >= blocksPerPage * (selectedPage - 1) && index < blocksPerPage * (selectedPage - 1) + blocksPerPage);
        setBlocks(blocksPaginated);
        setPage(selectedPage);
        setAllPages(Math.ceil(propsBlocks.length / 4));
    }, [propsBlocks, blocksPerPage]);
    // Update background color
    const updateBackground = useCallback((bgColorID, blockId) => {
        setBgColor((prev) => (Object.assign(Object.assign({}, prev), { [blockId]: bgColorID })));
    }, []);
    const prevGoToLastPageStateRef = useRef(goToLastPageState);
    const prevResetPageStateRef = useRef(resetPageState);
    const prevPropsBlocksLengthRef = useRef(propsBlocks.length);
    const prevPropsBlocksRef = useRef(propsBlocks);
    const prevBlocksRef = useRef(blocks);
    const pageNameIndex = getPageNameIndex(currentPage, settings, pagesCount);
    const endless = !!settings.pages[pageNameIndex].endless;
    const blocksPerPageDerived = blocksPerPage;
    // Layout-sensitive part (must run before Paint)
    useLayoutEffect(() => {
        if (pageRef.current) {
            updatePageSize(pageRef.current.offsetWidth, pageRef.current.offsetHeight);
        }
    }, [updatePageSize]);
    useEffect(() => {
        _isMounted.current = true;
        setFilterSlider('default', '');
        if (settings.pages[pageNameIndex].endless) {
            changePage(1);
            // setTimeout(() => changePage(1), 0);
        }
        else {
            setBlocks(propsBlocks);
        }
        initializeDeltaPositions();
        initDefaultPosition === null || initDefaultPosition === void 0 ? void 0 : initDefaultPosition();
        setIsPageInitialized(true);
        return () => {
            _isMounted.current = false;
            if (hideLoadingTimeoutRef.current) {
                clearTimeout(hideLoadingTimeoutRef.current);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        if (type === 'active' && pageRef.current) {
            setActiveHeight(parseInt(pageRef.current.offsetHeight.toString(), 10));
        }
    }, [type, setActiveHeight]);
    useEffect(() => {
        if (!endless)
            return;
        const currentBlocksLength = propsBlocks.length;
        const previousBlocksLength = prevPropsBlocksLengthRef.current;
        if (prevGoToLastPageStateRef.current !== goToLastPageState) {
            changePage(allPages);
            goToLastPage(false);
        }
        else if ((prevResetPageStateRef.current !== resetPageState && resetPageState) || updateBlocksState) {
            changePage(page);
            resetStates(pageNameIndex);
        }
        else if (currentBlocksLength > previousBlocksLength) {
            // const newPage = Math.max(1, Math.ceil(currentBlocksLength / blocksPerPageDerived)); // same as allPages
            changePage(allPages);
        }
        else if (currentBlocksLength < previousBlocksLength) {
            changePage(1);
        }
        prevGoToLastPageStateRef.current = goToLastPageState;
        prevResetPageStateRef.current = resetPageState;
        prevPropsBlocksLengthRef.current = currentBlocksLength;
    }, [
        endless,
        goToLastPageState,
        resetPageState,
        updateBlocksState,
        propsBlocks.length,
        changePage,
        allPages,
        goToLastPage,
        page,
        resetStates,
        pageNameIndex,
        blocksPerPageDerived,
    ]);
    useEffect(() => {
        if (endless)
            return;
        let shouldUpdateBlocks = false;
        const blockStateChanged = JSON.stringify(prevBlocksRef.current) !== JSON.stringify(propsBlocks);
        // let blockPropsChanged = JSON.stringify(prevPropsBlocksRef.current) !== JSON.stringify(propsBlocks);
        try {
            if (JSON.stringify(prevBlocksRef.current) !== JSON.stringify(propsBlocks)) {
                shouldUpdateBlocks = true;
            }
        }
        catch (error) {
            console.warn('Block comparison failed, using reference comparison:', error);
            if (prevBlocksRef.current !== propsBlocks) {
                shouldUpdateBlocks = true;
            }
        }
        if (shouldUpdateBlocks) {
            setBlocks(propsBlocks);
            initializeDeltaPositions();
        }
        prevBlocksRef.current = blocks;
    }, [endless, propsBlocks, blocks, setBlocks, initializeDeltaPositions]);
    const switchBlock = useCallback((e) => {
        changeBlock === null || changeBlock === void 0 ? void 0 : changeBlock(e);
    }, [changeBlock]);
    const hideLoading = useCallback(() => {
        if (hideLoadingTimeoutRef.current) {
            clearTimeout(hideLoadingTimeoutRef.current);
        }
        hideLoadingTimeoutRef.current = setTimeout(() => {
            if (_isMounted.current) {
                setLoading(false);
            }
        }, 200);
    }, []);
    const deleteBlock = useCallback((e) => {
        var _a;
        const { target } = e;
        const sourceRasterId = target.getAttribute('data-block');
        const indexOfParent = _.findIndex(propsBlocks, ['id', sourceRasterId]);
        const parent = (_a = propsBlocks[indexOfParent]) === null || _a === void 0 ? void 0 : _a.block_combination_parent;
        let warning = messages.editor.delete_selected_content_block;
        if (parent !== undefined && parent !== '') {
            warning = messages.editor.delete_selected_content_block + ' ' + messages.editor.delete_children_of_parents;
        }
        const options = {
            title: messages.editor.delete_content,
            message: warning,
            buttons: [
                {
                    label: messages.editor.yes_delete,
                    onClick: () => {
                        changePage(page);
                        removeContentBlock === null || removeContentBlock === void 0 ? void 0 : removeContentBlock(target);
                    },
                },
                {
                    label: messages.editor.rather_not,
                    onClick: () => { },
                },
            ],
            childrenElement: () => _jsx("div", {}),
            closeOnEscape: true,
            closeOnClickOutside: true,
        };
        confirmAlert(options);
    }, [propsBlocks, messages, changePage, page, removeContentBlock]);
    const resBlock = useCallback((e) => {
        const { target } = e;
        const options = {
            title: messages.editor.reset_content,
            message: messages.editor.reset_content_block_to_root,
            buttons: [
                {
                    label: messages.editor.yes_reset,
                    onClick: () => {
                        resetBlock(target);
                    },
                },
                {
                    label: messages.editor.rather_not,
                    onClick: () => { },
                },
            ],
            childrenElement: () => _jsx("div", {}),
            closeOnEscape: true,
            closeOnClickOutside: true,
        };
        confirmAlert(options);
    }, [messages, resetBlock]);
    const pasteBlockF = useCallback((e, type = '') => {
        pasteBlock === null || pasteBlock === void 0 ? void 0 : pasteBlock(e, type);
    }, [pasteBlock]);
    const copyBlockF = useCallback((e, type = '') => {
        copyBlock === null || copyBlock === void 0 ? void 0 : copyBlock(e, type);
        // Tooltip.rebuild();
    }, [copyBlock]);
    const resizeBlockF = useCallback((e) => {
        resizeBlock(e.target);
        // Tooltip.rebuild();
    }, [resizeBlock]);
    const gotoPage = useCallback(() => {
        updateCurrentPage(parseInt(currentPage.toString(), 10));
    }, [currentPage, updateCurrentPage]);
    const getIndexForImage = useCallback((blockId) => {
        var _a;
        const bIndex = _findIndex(propsBlocks, ['id', blockId]);
        if (typeof propsBlocks[bIndex].params !== 'undefined' && bIndex !== -1) {
            if (propsBlocks[bIndex].params.length === 1 && ((_a = propsBlocks[bIndex].params[0]) === null || _a === void 0 ? void 0 : _a.thumb)) {
                setIndexOfImage(0);
                setBlockForFilter(propsBlocks[bIndex]);
                filterImage(blockId); // callback i.o.
            }
            else {
                setIndexOfImage(undefined);
                setBlockForFilter(propsBlocks[bIndex]);
                setShowFilter(true); // callback i.o.
            }
        }
    }, [propsBlocks]);
    const filterImage = useCallback((blockId) => {
        const bIndex = _findIndex(propsBlocks, ['id', blockId]);
        if (indexOfImage !== undefined &&
            propsBlocks[bIndex].params[indexOfImage] &&
            propsBlocks[bIndex].params[indexOfImage].filter !== undefined &&
            propsBlocks[bIndex].params[indexOfImage].filter !== null) {
            setBlockForFilter(propsBlocks[bIndex]); // callback i.o.
            const source = propsBlocks[bIndex].params[indexOfImage].filter; // callback i.o.
            const newFilter = {
                grayscale: 0,
                sepia: 0,
                blur: 0,
                brightness: 1,
                contrast: 1,
                rotate: 0,
                invert: 0,
                opacity: 1,
                saturate: 1,
                shadow: 0,
            };
            Object.keys(newFilter).forEach((prop) => {
                const attributeName = prop === 'rotate' ? 'hue-rotate' : prop;
                const value = getAttributeValue(source, attributeName);
                newFilter[prop] = value !== null ? Number(value) : newFilter[prop];
            });
            setFilterState(newFilter); // callback i.o.
            let _filterAsString = '';
            for (const [key, value] of Object.entries(newFilter)) {
                if (value !== 0) {
                    if (key === 'rotate') {
                        _filterAsString = _filterAsString + 'hue-rotate(' + value + 'deg) ';
                    }
                    else if (key === 'blur') {
                        _filterAsString = _filterAsString + key + '(' + value + 'px) ';
                    }
                    else {
                        _filterAsString = _filterAsString + key + '(' + value + ') ';
                    }
                }
            }
            const _outputRange = [_jsx("div", {}, "default")];
            setFilterAsString(_filterAsString);
            setCurrentFilterData('');
            setOutputRange(_outputRange); // callback i. o.
            setShowFilter(true);
        }
        else {
            const _outputRange = [_jsx("div", {}, "default")];
            let _filterAsString = '';
            const _filter = {
                grayscale: 0,
                sepia: 0,
                blur: 0,
                brightness: 1,
                contrast: 1,
                shadow: 0,
                rotate: 0,
                invert: 0,
                opacity: 1,
                saturate: 1,
            };
            for (const [key, value] of Object.entries(_filter)) {
                if (value !== 0) {
                    if (key === 'rotate') {
                        _filterAsString = _filterAsString + 'hue-rotate(' + value + 'deg) ';
                    }
                    else if (key === 'blur') {
                        _filterAsString = _filterAsString + key + '(' + value + 'px) ';
                    }
                    else {
                        _filterAsString = _filterAsString + key + '(' + value + ') ';
                    }
                }
            }
            setBlockForFilter(propsBlocks[bIndex]);
            setFilterState(_filter);
            setCurrentFilterData('');
            setOutputRange(_outputRange);
            setFilterAsString(_filterAsString);
            setShowFilter(true);
        }
    }, [propsBlocks, indexOfImage]);
    const setIndexOfImageHandler = useCallback((name, value) => {
        if (!blockForFilter)
            return;
        const _indexOfImage = _.findIndex(blockForFilter.params, (param) => param.name === name);
        setIndexOfImage(_indexOfImage);
        filterImage(blockForFilter.id);
    }, [blockForFilter, filterImage]);
    const getImageUrlSettings = useCallback((blockId) => {
        var _a, _b, _c, _d, _e;
        const blockIndex = _findIndex(propsBlocks, ['id', blockId]);
        setBlockForUrl(propsBlocks[blockIndex]);
        // callback i. o.
        if (((_b = (_a = propsBlocks[blockIndex]) === null || _a === void 0 ? void 0 : _a.params[0]) === null || _b === void 0 ? void 0 : _b.url) !== undefined && propsBlocks[blockIndex].params[0].url !== null) {
            setImgUrl((_e = (_d = (_c = propsBlocks[blockIndex]) === null || _c === void 0 ? void 0 : _c.params[0]) === null || _d === void 0 ? void 0 : _d.url) !== null && _e !== void 0 ? _e : '');
        }
        else {
            setImgUrl(''); // callback i. o.
        }
        setShowUrl(true);
    }, [propsBlocks]);
    const extractImgAttributes = useCallback((element) => {
        const regex = /<img[\s\S]*?src="(.*?)"[\s\S]*?data-name="(.*?)"/;
        const match = element.match(regex);
        if (match) {
            const src = match[1];
            const dataName = match[2];
            return { src, dataName };
        }
        return null;
    }, []);
    const saveUrl = useCallback(() => {
        var _a, _b, _c, _d, _e;
        if (!blockForUrl)
            return;
        const id = blockForUrl.id;
        let value = '';
        let name = '';
        let errors = null;
        let thumb = '';
        let filter = '';
        if (blockForUrl.params.length > 0) {
            value = ((_a = blockForUrl.params[0]) === null || _a === void 0 ? void 0 : _a.value) || '';
            name = ((_b = blockForUrl.params[0]) === null || _b === void 0 ? void 0 : _b.name) || '';
            errors = (_c = blockForUrl.params[0]) === null || _c === void 0 ? void 0 : _c.errors;
            thumb = ((_d = blockForUrl.params[0]) === null || _d === void 0 ? void 0 : _d.thumb) || '';
            filter = ((_e = blockForUrl.params[0]) === null || _e === void 0 ? void 0 : _e.filter) || '';
        }
        else {
            const attributes = extractImgAttributes(blockForUrl.template);
            value = (attributes === null || attributes === void 0 ? void 0 : attributes.src) || '';
            name = (attributes === null || attributes === void 0 ? void 0 : attributes.dataName) || '';
            errors = null;
            thumb = '';
            filter = '';
        }
        updateSpecialBlockAttributes(id, name, value, thumb, errors, filter, imgUrl);
        setShowUrl(false);
    }, [blockForUrl, imgUrl, extractImgAttributes, updateSpecialBlockAttributes]);
    const handleIEClose = useCallback(() => {
        setShowFilter(false);
        setShowUrl(false);
    }, []);
    const saveFilter = useCallback(() => {
        if (!blockForFilter || indexOfImage === undefined)
            return;
        const { id } = blockForFilter;
        const param = blockForFilter.params[indexOfImage];
        const { value = '', name = '' } = param;
        const errors = param.errors !== undefined ? blockForFilter.errors : null;
        const thumb = (param === null || param === void 0 ? void 0 : param.thumb) || '';
        const url = (param === null || param === void 0 ? void 0 : param.url) || '';
        updateSpecialBlockAttributes(id, name, value, thumb, errors, filterAsString, url);
        setShowFilter(false);
    }, [blockForFilter, indexOfImage, filterAsString, updateSpecialBlockAttributes]);
    const setFilter = useCallback((e) => {
        const element = e.target;
        let _filterAsString = '';
        setFilterState((prev) => {
            const newFilter = Object.assign({}, prev);
            switch (element.name) {
                case 'grayscale':
                    newFilter.grayscale = Number(element.value);
                    break;
                case 'sepia':
                    newFilter.sepia = Number(element.value);
                    break;
                case 'blur':
                    newFilter.blur = Number(element.value);
                    break;
                case 'brightness':
                    newFilter.brightness = Number(element.value);
                    break;
                case 'contrast':
                    newFilter.contrast = Number(element.value);
                    break;
                case 'drop-shadow':
                    newFilter.shadow = Number(element.value);
                    break;
                case 'hue-rotate':
                    newFilter.rotate = Number(element.value);
                    break;
                case 'invert':
                    newFilter.invert = Number(element.value);
                    break;
                case 'opacity':
                    newFilter.opacity = Number(element.value);
                    break;
                case 'saturate':
                    newFilter.saturate = Number(element.value);
                    break;
                default:
                    break;
            }
            for (const [key, value] of Object.entries(newFilter)) {
                if (value !== 0) {
                    if (key === 'rotate') {
                        _filterAsString = _filterAsString + 'hue-rotate(' + value + 'deg) ';
                    }
                    else if (key === 'blur') {
                        _filterAsString = _filterAsString + key + '(' + value + 'px) ';
                    }
                    else {
                        _filterAsString = _filterAsString + key + '(' + value + ') ';
                    }
                }
            }
            setFilterAsString(_filterAsString);
            return newFilter;
        });
        setCurrentFilterData(element.value);
    }, []);
    const setFilterSlider = useCallback((nameF, valueF) => {
        const min = 0;
        let max = 1;
        let step = 0.1;
        const htmlFor = valueF;
        const id = valueF;
        const name = valueF;
        let _default = 0;
        let _defaultValue = 0;
        let message = '';
        switch (valueF) {
            case 'blur':
                max = 10;
                step = 1;
                _defaultValue = filter.blur;
                message = messages.editor.filter_blur;
                break;
            case 'brightness':
                max = 3;
                _defaultValue = filter.brightness;
                message = messages.editor.filter_brightness;
                _default = 1;
                break;
            case 'contrast':
                max = 3;
                _defaultValue = filter.contrast;
                message = messages.editor.filter_contrast;
                _default = 1;
                break;
            case 'hue-rotate':
                max = 360;
                step = 1;
                _defaultValue = filter.rotate;
                message = messages.editor.filter_hueRotate;
                break;
            case 'saturate':
                max = 3;
                _defaultValue = filter.saturate;
                message = messages.editor.filter_saturate;
                _default = 1;
                break;
            case 'sepia':
                _defaultValue = filter.sepia;
                message = messages.editor.filter_sepia;
                break;
            case 'grayscale':
                _defaultValue = filter.grayscale;
                message = messages.editor.filter_grayscale;
                break;
            case 'invert':
                _defaultValue = filter.invert;
                message = messages.editor.filter_invert;
                break;
            case 'opacity':
                _defaultValue = filter.opacity;
                message = messages.editor.filter_opacity;
                _default = 1;
                break;
            default:
                break;
        }
        const _outputRange = [];
        if (nameF === 'default') {
            _outputRange.push(_jsx("div", {}, "default"));
        }
        else {
            setCurrentFilterData(_defaultValue.toString());
            _outputRange.push(_jsxs("div", { children: [_jsxs("label", { htmlFor: htmlFor, children: [message, " ", messages.editor.filter_default, ": ", _default] }), _jsx("input", { type: "range", id: id, name: name, min: min, max: max, defaultValue: _defaultValue, step: step, onChange: setFilter })] }, _defaultValue));
        }
        setOutputRange(_outputRange);
    }, [filter, messages, setFilter]);
    // Render logic
    const zoomEqualizer = 1 / parseFloat(pageZoom.toString());
    const paddingStyle = '';
    const marginTop = paddingTop || 0;
    const marginBottom = paddingBottom || 0;
    // const pageNameIndex = getPageNameIndex(currentPage, settings, pagesCount);
    let displayedBlocks = [];
    if (endless) {
        displayedBlocks = blocks;
    }
    else {
        displayedBlocks = propsBlocks;
    }
    const noCopies = _.findIndex(displayedBlocks, ['no_copies', true], 0);
    let fromIndex = _.findIndex(displayedBlocks, ['fixed', true], 0);
    const fixedBlocks = [];
    while (fromIndex !== -1) {
        const fixedBlock = _.find(displayedBlocks, ['fixed', true], fromIndex);
        if (fixedBlock) {
            fixedBlocks.push(fixedBlock.id);
        }
        fromIndex = _.findIndex(displayedBlocks, ['fixed', true], fromIndex + 1);
    }
    const freeSlots = getRasterSlots(raster, currentPage, settings.pages[pageNameIndex].page_space, 0, 0, endless);
    const rasterV = Math.floor((pageHeight - marginTop - marginBottom) / settings.pages[pageNameIndex].page_space);
    const styles = {
        transform: `scale(${pageZoom})`,
        width: pageWidth + 'px',
        height: pageHeight + 'px',
        marginLeft: (marginWidth - pageWidth) * pageZoom + 100 + 'px',
    };
    const arrow = {
        display: 'block',
    };
    if (website) {
        styles.height = 'auto';
        styles.minHeight = pageHeight + 'px';
    }
    const styleOptions = {
        transform: `scale(${zoomEqualizer})`,
    };
    let pasteButton = '';
    let pasteButton2 = '';
    let blockPasteDisableGlobal = true;
    let blockPasteDisableBlockContainer = false;
    let copyAllButton = '';
    if (type === 'previous' || type === 'next') {
        styles.opacity = '0.5';
        styles.zIndex = 1;
        arrow.display = 'none';
    }
    else if (type === 'active') {
        if (displayedBlocks.length > 0) {
            copyAllButton = (_jsx(Button, { size: "sm", "data-tooltip-content": messages.editor.copy_full_content, "data-tooltip-id": "blockinfo2", "data-block": "all", onClick: copyBlockF, variant: "light", children: _jsx("i", { className: "fas fa-clone", "data-block": "all" }) }));
        }
        if (pasteData) {
            let spaceNeeded = 0;
            let restrictedToPage = false;
            let excludePages = false;
            let oncePerPage = false;
            let oncePerVariant = false;
            let oncePerCategory = false;
            let oncePerDocument = false;
            let parentNotAvailable = false;
            let disableGroup = false;
            let onlyInsideBlock = false;
            let inner = false;
            _.forEach(copiedBlock, (block) => {
                var _a;
                spaceNeeded += block.page_space_needed;
                onlyInsideBlock = (block === null || block === void 0 ? void 0 : block.only_inside_block) || false;
                inner = (block === null || block === void 0 ? void 0 : block.inner) || false;
                if (restrictedToPage) {
                    restrictedToPage = block.restricted_to_page || false;
                }
                if (block.exclude_pages) {
                    if (block.exclude_pages.indexOf((currentPage + 1).toString()) >= 0) {
                        excludePages = true;
                    }
                }
                if (block.once_per_page) {
                    if (_.findIndex(displayedBlocks, ['template_id', block.template_id]) >= 0) {
                        oncePerPage = true;
                    }
                    else if (oncePerPage === false) {
                        _.forEach(displayedBlocks, (_block) => {
                            if (_.findIndex(_block.blocks, ['template_id', block.template_id]) >= 0) {
                                oncePerPage = true;
                            }
                        });
                    }
                }
                if (typeof block.once_per_variant !== 'undefined' &&
                    block.once_per_variant !== '' &&
                    _findIndex(displayedBlocks, ['once_per_variant', block.once_per_variant]) !== -1) {
                    oncePerVariant = true;
                }
                else if (typeof block.once_per_variant !== 'undefined' &&
                    block.once_per_variant !== '' &&
                    _findIndex(displayedBlocks, ['once_per_variant', block.once_per_variant]) === -1) {
                    _.forEach(displayedBlocks, (_block) => {
                        if (_.findIndex(_block.blocks, ['once_per_variant', block.once_per_variant]) >= 0) {
                            oncePerVariant = true;
                        }
                    });
                }
                if (typeof block.once_per_category !== 'undefined' &&
                    block.once_per_category !== '' &&
                    _findIndex(displayedBlocks, ['once_per_category', block.once_per_category]) !== -1) {
                    oncePerCategory = true;
                }
                else if (typeof block.once_per_category !== 'undefined' &&
                    block.once_per_category !== '' &&
                    _findIndex(displayedBlocks, ['once_per_category', block.once_per_category]) === -1) {
                    _.forEach(displayedBlocks, (_block) => {
                        if (_.findIndex(_block.blocks, ['once_per_category', block.once_per_category]) >= 0) {
                            oncePerCategory = true;
                        }
                    });
                }
                if (block.once_per_document && _.findIndex(allUsedBlocks, ['id', block.template_id]) >= 0) {
                    oncePerDocument = true;
                }
                if (block.block_combination_child !== '') {
                    parentNotAvailable = true;
                    const blockCombinationChild = ((_a = block.block_combination_child) === null || _a === void 0 ? void 0 : _a.split(',')) || [];
                    _forEach(blockCombinationChild, (blockCC) => {
                        if (_findIndex(displayedBlocks, ['block_combination_parent', blockCC]) !== -1) {
                            parentNotAvailable = false;
                        }
                    });
                    if (parentNotAvailable === true) {
                        _.forEach(displayedBlocks, (_block) => {
                            _forEach(blockCombinationChild, (blockCC) => {
                                if (_findIndex(_block.blocks, ['block_combination_parent', blockCC]) !== -1) {
                                    parentNotAvailable = false;
                                }
                            });
                        });
                    }
                }
                if (block.disable_group !== '' && block.disable_group !== undefined) {
                    let usedBlockVariant = displayedBlocks;
                    const splitBlockOptions = block.disable_group.split('#');
                    const splitBlockVariants = splitBlockOptions[0].split(',');
                    const splitDisableGroups = splitBlockOptions[1].split(',');
                    _forEach(splitDisableGroups, (blockDG, i) => {
                        if (splitBlockVariants[i] === 'D') {
                            usedBlockVariant = allUsedBlocksContent;
                        }
                        let even = false;
                        if (i % 2 === 0) {
                            even = true;
                        }
                        if (even) {
                            _forEach(usedBlockVariant, (_usedBlock) => {
                                let splitUsedBlockDisableGroups = [];
                                if (_usedBlock.disable_group !== '' && _usedBlock.disable_group !== undefined) {
                                    splitUsedBlockDisableGroups = _usedBlock.disable_group.split('#');
                                    const splitUsedDisableGroups = splitUsedBlockDisableGroups[1].split(',');
                                    if ((splitUsedDisableGroups === null || splitUsedDisableGroups === void 0 ? void 0 : splitUsedDisableGroups.length) > 0 &&
                                        splitUsedDisableGroups[i + 1] === splitDisableGroups[i] &&
                                        splitUsedDisableGroups[i + 1] !== 'x' &&
                                        splitDisableGroups[i] !== 'x') {
                                        disableGroup = true;
                                    }
                                }
                            });
                            if (disableGroup === false) {
                                _forEach(usedBlockVariant, (_usedBlock) => {
                                    var _a;
                                    if ((_usedBlock === null || _usedBlock === void 0 ? void 0 : _usedBlock.blocks) && ((_a = _usedBlock === null || _usedBlock === void 0 ? void 0 : _usedBlock.blocks) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                                        _.forEach(_usedBlock === null || _usedBlock === void 0 ? void 0 : _usedBlock.blocks, (blockInsideContainer) => {
                                            let splitUsedBlockDisableGroupsIC = [];
                                            if (blockInsideContainer.disable_group !== '' &&
                                                blockInsideContainer.disable_group !== undefined) {
                                                splitUsedBlockDisableGroupsIC = blockInsideContainer.disable_group.split('#');
                                                const splitUsedDisableGroupsIC = splitUsedBlockDisableGroupsIC[1].split(',');
                                                if ((splitUsedDisableGroupsIC === null || splitUsedDisableGroupsIC === void 0 ? void 0 : splitUsedDisableGroupsIC.length) > 0 &&
                                                    splitUsedDisableGroupsIC[i + 1] === splitDisableGroups[i] &&
                                                    splitUsedDisableGroupsIC[i + 1] !== 'x' &&
                                                    splitDisableGroups[i] !== 'x') {
                                                    disableGroup = true;
                                                }
                                            }
                                        });
                                    }
                                });
                            }
                        }
                    });
                }
            });
            _.forEach(freeSlots, (slot) => {
                if (slot >= spaceNeeded) {
                    blockPasteDisableGlobal = false;
                }
            });
            if (endless) {
                blockPasteDisableGlobal = false;
            }
            if ((restrictedToPage && restrictedToPage - 1 !== currentPage) ||
                excludePages ||
                oncePerPage ||
                oncePerVariant ||
                oncePerCategory ||
                oncePerDocument ||
                (parentNotAvailable && copiedBlock && copiedBlock.length === 1)) {
                blockPasteDisableGlobal = true;
                blockPasteDisableBlockContainer = true;
            }
            if (onlyInsideBlock) {
                blockPasteDisableGlobal = true;
            }
            if (!inner) {
                blockPasteDisableBlockContainer = true;
            }
            pasteButton2 = (_jsx(Button, { size: "sm", "data-tooltip-content": messages.editor.paste_content, disabled: blockPasteDisableGlobal, "data-tooltip-id": "blockinfo2", "data-block": "-1", onClick: pasteBlockF, variant: "light", children: _jsx("i", { className: "fas fa-sign-in fa-rotate-90", "data-block": "-1" }) }));
        }
    }
    const options = [
        ['sepia', messages.editor.filter_sepia],
        ['grayscale', messages.editor.filter_grayscale],
        ['blur', messages.editor.filter_blur],
        ['brightness', messages.editor.filter_brightness],
        ['contrast', messages.editor.filter_contrast],
        ['hue-rotate', messages.editor.filter_hueRotate],
        ['invert', messages.editor.filter_invert],
        ['opacity', messages.editor.filter_opacity],
        ['saturate', messages.editor.filter_saturate],
    ];
    const _currentPage = 'page_' + (currentPage * 1 + 1);
    let pageColorClasses = '';
    let filteredColorSettings = [];
    filteredColorSettings = _.filter(colorSettings, (setting) => setting.id === _currentPage);
    _forEach(filteredColorSettings, (filteredColorSetting, i) => {
        pageColorClasses = pageColorClasses + ' ' + filteredColorSetting.color;
    });
    const imagesForFilterPreview = [];
    _forEach(blockForFilter === null || blockForFilter === void 0 ? void 0 : blockForFilter.params, (param, i) => {
        if (param.thumb) {
            let active = '5px solid transparent';
            if (indexOfImage === i) {
                active = '5px solid #28a745';
            }
            imagesForFilterPreview.push(_jsx("div", { style: {
                    position: 'relative',
                    border: active,
                    margin: '5px',
                }, children: _jsx("img", { src: param.thumb, className: "img-selection", alt: 'Image' + i, style: { width: '50px', height: '50px', margin: '1px', objectFit: 'cover', cursor: 'pointer' }, onClick: () => setIndexOfImageHandler(param.name || '', param.value || '') }, i) }, i));
        }
    });
    return (_jsxs(_Fragment, { children: [showFilter && (_jsx(ContextModal, { children: _jsx("div", { id: "contextModalWrap", children: _jsxs("div", { id: "contextModalStage", className: "row", children: [_jsx("h1", { children: messages.editor.filter_settings }), _jsx("h5", { children: messages.choose_image_for_filter }), _jsx("div", { style: { display: 'flex' }, children: imagesForFilterPreview }), (indexOfImage || indexOfImage === 0) && (_jsxs("div", { className: "filter-settings", children: [_jsx("img", { style: { maxWidth: '50%', margin: '10px', filter: filterAsString }, src: (_b = blockForFilter === null || blockForFilter === void 0 ? void 0 : blockForFilter.params[indexOfImage]) === null || _b === void 0 ? void 0 : _b.value, alt: "", className: `img-preview-${indexOfImage}` }), _jsxs("div", { children: [_jsx("div", { children: _jsx(FormAutocomplete, { onChange: (name, value) => {
                                                        setFilterSlider(name, value);
                                                    }, value: "", label: messages.editor.filter_selection, name: "choise_filter", className: "choose_filter_for_image", options: options.map((option) => {
                                                        return { label: option[1], value: option[0] };
                                                    }) }) }), _jsxs("div", { children: [_jsx("p", { className: "filter-set", style: { marginTop: '10px', fontSize: '14px' }, children: currentFilterData && messages.editor.filter_set + ': ' + currentFilterData }), outputRange] })] }), _jsx(Button, { variant: "success", size: "lg", style: { position: 'fixed', left: '8vw', top: '85%', zIndex: '100', width: 'max-content' }, onClick: saveFilter, children: messages.editor.use_filter })] })), _jsx(Button, { variant: "danger", size: "lg", onClick: handleIEClose, className: "cancelIE", children: messages.editor.abort })] }) }) })), showUrl && (_jsx(ContextModal, { children: _jsx("div", { id: "contextModalWrap", children: _jsxs("div", { id: "contextModalStage", className: "row", children: [_jsx("h1", { children: messages.url_settings }), _jsx(FormInput, { type: "text", label: "Url", name: "url", onChange: (name, value) => {
                                    setImgUrl(value);
                                }, value: imgUrl }), _jsxs("div", { className: "modal-default-style", children: [_jsx(Button, { variant: "success", size: "lg", style: { position: 'fixed', left: '8vw', top: '85%', zIndex: '100' }, onClick: saveUrl, children: messages.editor.use_filter }), _jsx(Button, { className: "cancelIE", variant: "danger", size: "lg", onClick: handleIEClose, children: messages.editor.abort })] })] }) }) })), paddingStyle.length > 0 ? _jsx(EditorApplyStylesFTs, { styles: paddingStyle }) : null, _jsxs("div", { ref: pageRef, id: "page", className: type + grid + ' page seite_' + (currentPage + 1) + ' anzahl_' + pagesCount + evenOdd + pageColorClasses, style: styles, onClick: type !== 'active' ? gotoPage : undefined, children: [_jsxs("div", { className: 'ui_beschnitt' + trimBorderActive, children: [_jsx("div", { id: "ui_beschnitt_oben", className: "ui_beschnitt_oben" }), _jsx("div", { id: "ui_beschnitt_unten", className: "ui_beschnitt_unten" }), _jsx("div", { id: "ui_beschnitt_links", className: "ui_beschnitt_links" }), _jsx("div", { id: "ui_beschnitt_rechts", className: "ui_beschnitt_rechts" })] }), type === 'active' ? (_jsxs("div", { className: "block-options2", style: styleOptions, children: [copyAllButton, pasteButton2, getDeviceType && getDeviceType() === 'desktop' && (_jsx(Tooltip, { id: "blockinfo2", place: "left" }))] })) : null, endless && loading ? (_jsx("div", { style: {
                            height: '100%',
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }, children: _jsx(Loader, { small: true }) })) : (_jsx(DndContext, { sensors: sensors, onDragEnd: handleDragEnd, children: displayedBlocks.length > 0 &&
                            displayedBlocks.map((block, i) => {
                                var _a, _b;
                                const sectionClassPre = block.template ? block.template.match(/(?:data-section=").*?(?=\s*")/gm) : [''];
                                const sectionClass = sectionClassPre ? ' ' + sectionClassPre[0].replace('data-section="', '') : '';
                                let offsetTop = block.page_space_needed !== 0 ? block.top : null;
                                if (offsetTop === -1 || offsetTop === null || typeof offsetTop === 'undefined') {
                                    offsetTop = getBlockTopFromRaster(raster, currentPage, block.id);
                                    offsetTop = offsetTop < 0 ? 0 : offsetTop;
                                }
                                const safeOffsetTop = offsetTop !== null && offsetTop !== void 0 ? offsetTop : 0;
                                const siblings = getSiblings(raster, currentPage, block.id);
                                let previousBlock = null;
                                let nextBlock = null;
                                if (siblings.up !== '') {
                                    previousBlock = _.find(displayedBlocks, ['id', siblings.up]) || null;
                                }
                                if (siblings.down !== '') {
                                    nextBlock = _.find(displayedBlocks, ['id', siblings.down]) || null;
                                }
                                let blockUp = null;
                                let blockDown = null;
                                let blockUpDisable = true;
                                let blockDownDisable = true;
                                let blockDeleteDisable = false;
                                const blockEditDisable = false;
                                let blockBiggerDisable = false;
                                const blockSmallerDisable = false;
                                let blockCopyDisable = false;
                                let biggerButton = '';
                                let smallerButton = '';
                                let multiplePagesBlockClass = '';
                                let bottomClass = '';
                                const blockHeight = rasterV * block.page_space_needed;
                                const vPos = parseFloat(marginTop.toString()) + (endless ? i : safeOffsetTop) * rasterV;
                                const verticalPosition = {
                                    top: vPos + 'px',
                                    height: blockHeight + 'px',
                                };
                                if (block.bottom) {
                                    verticalPosition.bottom = block.bottom + 'px';
                                    bottomClass = ' page-bottom';
                                }
                                if (block.once_per_document || block.no_copies) {
                                    blockCopyDisable = true;
                                }
                                if (typeof block.oversize !== 'undefined' && block.oversize !== 0) {
                                    multiplePagesBlockClass = ' page-span-' + block.oversize.toString() + ' ' + block.oversize_position;
                                }
                                if (block.bigger !== null && block.bigger !== undefined && type === 'active') {
                                    blockBiggerDisable = true;
                                    if (fixedBlocks.length > 0) {
                                        let slotsBetween = [];
                                        let offsetTopFBlock;
                                        _.forEach(fixedBlocks, (fBlock, count) => {
                                            offsetTopFBlock = getBlockTopFromRaster(raster, currentPage, fBlock);
                                            if (offsetTopFBlock > safeOffsetTop || fixedBlocks.length === count + 1) {
                                                if (fixedBlocks.length === count + 1 && offsetTopFBlock <= safeOffsetTop) {
                                                    slotsBetween = getRasterSlots(raster, currentPage, settings.pages[pageNameIndex].page_space, safeOffsetTop, 0);
                                                }
                                                else {
                                                    slotsBetween = getRasterSlots(raster, currentPage, settings.pages[pageNameIndex].page_space, 0, 0);
                                                }
                                                _.forEach(slotsBetween, (slotB) => {
                                                    const biggerNeeded = block.bigger_needed || 0;
                                                    if (slotB >= biggerNeeded - block.page_space_needed) {
                                                        blockBiggerDisable = false;
                                                    }
                                                });
                                                return false;
                                            }
                                        });
                                    }
                                    else {
                                        _.forEach(freeSlots, (slot) => {
                                            const biggerNeeded = block.bigger_needed || 0;
                                            if (slot >= biggerNeeded - block.page_space_needed) {
                                                blockBiggerDisable = false;
                                            }
                                        });
                                    }
                                    biggerButton = (_jsx(Button, { "data-tooltip-content": messages.editor.enlarge_block, disabled: blockBiggerDisable, "data-tooltip-id": "blockinfo", "data-block": block.id, "data-template": block.bigger, onClick: resizeBlockF, variant: "light", children: _jsx("i", { className: "fas fa-expand-alt", "data-block": block.id, "data-template": block.bigger }) }));
                                }
                                if (block.smaller !== null && block.smaller !== undefined && type === 'active') {
                                    smallerButton = (_jsx(Button, { "data-tooltip-content": messages.editor.shrink_block, disabled: blockSmallerDisable, "data-tooltip-id": "blockinfo", "data-block": block.id, "data-template": block.smaller, onClick: resizeBlockF, variant: "light", children: _jsx("i", { className: "fas fa-compress-alt", "data-block": block.id, "data-template": block.smaller }) }));
                                }
                                let error = '';
                                let errorText = '';
                                if (block.errors.overflow) {
                                    error = 'overflow';
                                    errorText = messages.editor.text_overflow;
                                }
                                if (block.errors.default_image) {
                                    error += ' default-image';
                                    errorText += messages.editor.initial_image_available;
                                }
                                if (block.errors.resolution_warning) {
                                    error += ' resolution_warning';
                                    errorText += messages.editor.resolution_too_low;
                                }
                                if (siblings.up !== '' &&
                                    !block.fixed &&
                                    typeof previousBlock !== 'undefined' &&
                                    previousBlock !== null &&
                                    !previousBlock.fixed) {
                                    blockUpDisable = false;
                                    blockUp = siblings.up;
                                }
                                if (siblings.down !== '' &&
                                    !block.fixed &&
                                    typeof nextBlock !== 'undefined' &&
                                    nextBlock !== null &&
                                    !nextBlock.fixed) {
                                    blockDownDisable = false;
                                    blockDown = siblings.down;
                                }
                                if (block.not_deletable) {
                                    blockDeleteDisable = true;
                                }
                                if (pasteData && type === 'active') {
                                    pasteButton = (_jsx(Button, { "data-tooltip-content": messages.editor.paste_content_after, disabled: blockPasteDisableGlobal || block.page_space_needed < 1, "data-tooltip-id": "blockinfo", "data-block": block.id, onClick: pasteBlockF, variant: "light", children: _jsx("i", { className: "fas fa-sign-in fa-rotate-90", "data-block": block.id }) }));
                                }
                                let parentClass = '';
                                if (block.parent_class !== undefined && block.parent_class !== null) {
                                    parentClass = ' ' + block.parent_class;
                                }
                                const heightClass = ' height_' + block.page_space_needed;
                                let containerClass = '';
                                let containerSelect = () => { };
                                if (block.container) {
                                    containerClass = ' block-container';
                                    containerSelect = () => setBlockContainer === null || setBlockContainer === void 0 ? void 0 : setBlockContainer(block.id);
                                    if (blockContainer === block.id) {
                                        containerClass += ' active';
                                    }
                                }
                                let inlineClass = '';
                                if (block.inline_block) {
                                    inlineClass = ' inline-block col-section';
                                }
                                let navId = '';
                                if (block.nav_link) {
                                    navId = block.nav_link.replace('#', '') + block.id;
                                }
                                let blockTemplate = _cloneDeep(block.template);
                                blockTemplate = blockTemplate.toLowerCase();
                                let positionX;
                                let positionY;
                                if (block.position_x !== undefined && block.position_x !== null) {
                                    positionX = block.position_x;
                                }
                                else {
                                    positionX = getNumericValue(blockTemplate, 'defaultpositionx') || 0;
                                }
                                if (block.position_y !== undefined && block.position_y !== null) {
                                    positionY = block.position_y;
                                }
                                else {
                                    positionY = getNumericValue(blockTemplate, 'defaultpositiony') || 0;
                                }
                                /* Todo - we can handle these settings by css or provide it here additional */
                                let bounds;
                                const blockNames = ['dragtop', 'dragleft', 'dragright', 'dragbottom'];
                                if (blockNames.some((blockName) => blockTemplate.includes(blockName))) {
                                    const boundsObj = { top: 0, left: 0, right: 0, bottom: 0 };
                                    blockNames.forEach((blockName) => {
                                        if (blockTemplate.includes(blockName)) {
                                            const propName = blockName.substring(4).toLowerCase();
                                            boundsObj[propName] = getNumericValue(blockTemplate, blockName);
                                        }
                                    });
                                    bounds = boundsObj;
                                }
                                let sectionColorClasses = '';
                                let filteredSectionColorSettings = [];
                                filteredSectionColorSettings = _.filter(colorSettings, (setting) => setting.id === (block === null || block === void 0 ? void 0 : block.id));
                                _forEach(filteredSectionColorSettings, (filteredSectionColorSetting, i) => {
                                    sectionColorClasses = sectionColorClasses + ' ' + filteredSectionColorSetting.color;
                                });
                                let sectionFontSize = ' ';
                                sectionFontSize = ' ' + ((_a = fontSizeSettings[block === null || block === void 0 ? void 0 : block.id]) !== null && _a !== void 0 ? _a : '') + ' ';
                                const blockPosition = { x: positionX, y: positionY };
                                let selectedObjectClass = '';
                                if (block.id === ((_b = selectedObjectForAI === null || selectedObjectForAI === void 0 ? void 0 : selectedObjectForAI.block) === null || _b === void 0 ? void 0 : _b.id)) {
                                    selectedObjectClass = 'selectedObject ';
                                }
                                return (_jsxs("section", { ref: sectionRef, id: navId || block.id, style: verticalPosition, className: bottomClass +
                                        multiplePagesBlockClass +
                                        parentClass +
                                        heightClass +
                                        containerClass +
                                        inlineClass +
                                        sectionClass +
                                        sectionColorClasses +
                                        sectionFontSize +
                                        selectedObjectClass, children: [block.template &&
                                            (block.template.includes('draggable') || block.template.includes('allowdraganddrop')) ? (_jsxs(DraggableWrapper, { id: block.id, position: blockPosition, pageZoom: pageZoom, onDragPosition: (id, x, y) => {
                                                dragOffsets.current[id] = { x, y };
                                            }, customBounds: bounds, children: [_jsx("i", { className: "fas fa-arrows", style: arrow }), type === 'active' ? (_jsx(EditorBlockFTs, { type: type, appIntl: appIntl, data: block, settings: settings, updateParam: updateParam, updateInnerBlock: updateInnerBlock, zoomEqualizer: zoomEqualizer, index: index + '.' + i, pageZoom: pageZoom, imageUpload: imageUpload, usedMedia: usedMedia, copyBlock: copyBlockF, pasteBlock: pasteBlockF, templateBlocks: templateBlocks, containerSelect: containerSelect, unsetBlockContainer: unsetBlockContainer, blockContainer: blockContainer, rasterV: rasterV, pasteData: pasteData, copiedBlock: copiedBlock, navEntry: navEntry, resetNavEntry: resetNavEntry, publisherInfo: publisherInfo, bgColor: bgColor[block.id], filesUploading: filesUploading, rootUser: rootUser, wlAdminUser: wlAdminUser, isSubmission: isSubmission, onlyWhitelabelAdminCanModifyBlocks: onlyWhitelabelAdminCanModifyBlocks, saveDescription: saveDescription, uploadError: uploadError, getDeviceType: getDeviceType, showKeyboard: showKeyboard, resizeBlock: resizeBlock, blockBiggerDisable: blockBiggerDisable, autoResizeSupported: true, blockPasteDisableBlockContainer: blockPasteDisableBlockContainer, setSelectedColor: setSelectedColor, currentPage: currentPage, getColorSettings: getColorSettings, deleteSelectedColor: deleteSelectedColor, colorSettings: colorSettings, setFontSizeSettings: setFontSizeSettings, fontSizeSettings: fontSizeSettings, i: i, stageWidth: stageWidth, changeErrors: changeErrors, updateBackgroundE: updateBackground, fitAuto: fitAuto, updateBlocksState: updateBlocksState, setSelectedObjectForAI: setSelectedObjectForAI, selectedObjectForAI: selectedObjectForAI }, block.id)) : (_jsx(PreviewBlockFTs, { data: block, index: index + '.' + i, rasterV: rasterV, setSelectedColor: setSelectedColor, currentPage: currentPage, updateParam: updateParam, getColorSettings: getColorSettings, setFontSizeSettings: setFontSizeSettings, fontSizeSettings: fontSizeSettings, updateInnerBlock: updateInnerBlock, usedMedia: usedMedia, appIntl: appIntl, type: type, imageUpload: imageUpload, colorSettings: colorSettings, updateBlocksState: updateBlocksState, settings: settings }))] })) : type === 'active' ? (_jsx(EditorBlockFTs, { type: type, appIntl: appIntl, data: block, settings: settings, updateParam: updateParam, updateInnerBlock: updateInnerBlock, zoomEqualizer: zoomEqualizer, index: index + '.' + i, pageZoom: pageZoom, imageUpload: imageUpload, usedMedia: usedMedia, copyBlock: copyBlockF, pasteBlock: pasteBlockF, templateBlocks: templateBlocks, containerSelect: containerSelect, unsetBlockContainer: unsetBlockContainer, blockContainer: blockContainer, rasterV: rasterV, pasteData: pasteData, copiedBlock: copiedBlock, navEntry: navEntry, resetNavEntry: resetNavEntry, publisherInfo: publisherInfo, bgColor: bgColor[block.id], filesUploading: filesUploading, rootUser: rootUser, wlAdminUser: wlAdminUser, isSubmission: isSubmission, onlyWhitelabelAdminCanModifyBlocks: onlyWhitelabelAdminCanModifyBlocks, saveDescription: saveDescription, uploadError: uploadError, getDeviceType: getDeviceType, showKeyboard: showKeyboard, resizeBlock: resizeBlock, blockBiggerDisable: blockBiggerDisable, autoResizeSupported: true, blockPasteDisableBlockContainer: blockPasteDisableBlockContainer, setSelectedColor: setSelectedColor, currentPage: currentPage, getColorSettings: getColorSettings, deleteSelectedColor: deleteSelectedColor, colorSettings: colorSettings, setFontSizeSettings: setFontSizeSettings, fontSizeSettings: fontSizeSettings, i: i, stageWidth: stageWidth, changeErrors: changeErrors, fitAuto: fitAuto, updateBlocksState: updateBlocksState, selectedObjectForAI: selectedObjectForAI, setSelectedObjectForAI: setSelectedObjectForAI }, block.id)) : (_jsx(PreviewBlockFTs, { data: block, index: index + '.' + i, rasterV: rasterV, setSelectedColor: setSelectedColor, currentPage: currentPage, updateParam: updateParam, getColorSettings: getColorSettings, setFontSizeSettings: setFontSizeSettings, fontSizeSettings: fontSizeSettings, updateInnerBlock: updateInnerBlock, usedMedia: usedMedia, appIntl: appIntl, type: type, imageUpload: imageUpload, colorSettings: colorSettings, updateBlocksState: updateBlocksState, settings: settings })), type === 'active' && !block.no_options ? (_jsxs("div", { className: "block-options", style: styleOptions, children: [_jsxs(ButtonGroup, { vertical: true, size: "sm", children: [block.container ? (blockContainer === block.id ? (_jsx(Button, { className: "select-container", "data-tooltip-content": messages.editor.deselect_element, "data-tooltip-id": "blockinfo", onClick: () => unsetBlockContainer === null || unsetBlockContainer === void 0 ? void 0 : unsetBlockContainer(), variant: "light", children: _jsx("i", { className: "fas fa-layer-minus" }) })) : (_jsx(Button, { className: "select-container", "data-tooltip-content": messages.editor.select_element, "data-tooltip-id": "blockinfo", onClick: () => setBlockContainer === null || setBlockContainer === void 0 ? void 0 : setBlockContainer(block.id), variant: "light", children: _jsx("i", { className: "fas fa-layer-plus" }) }))) : null, block.fixed ? (_jsx(Button, { className: "is-fixed", "data-tooltip-content": messages.editor.block_can_not_move, "data-tooltip-id": "blockinfo", children: _jsx("i", { className: "far fa-lock" }) })) : (_jsx(Button, { "data-tooltip-content": messages.editor.up, "data-tooltip-id": "blockinfo", disabled: blockUpDisable, "data-block": block.id, "data-target": blockUp, onClick: switchBlock, variant: "light", children: _jsx("i", { className: "far fa-angle-up", "data-block": block.id, "data-target": blockUp }) })), _jsxs("div", { className: "toggle-edit btn btn-light", "data-block": block.id, children: [_jsx("i", { className: "fas fa-edit", "data-block": block.id }), _jsxs(ButtonGroup, { className: "edit-block", size: "sm", vertical: true, children: [_jsx(Button, { "data-tooltip-content": messages.editor.reset_block, "data-tooltip-id": "blockinfo", "data-block": block.id, "data-template": block.template_id, onClick: resBlock, variant: "light", children: _jsx("i", { className: "fas fa-retweet", "data-block": block.id, "data-template": block.template_id }) }), block.template && block.template.includes('<img') && (_jsxs(_Fragment, { children: [_jsx(Button, { "data-tooltip-content": messages.editor.filter_settings, "data-tooltip-id": "blockinfo", "data-block": block.id, "data-template": block.template_id, onClick: () => getIndexForImage(block.id), variant: "light", children: _jsx("i", { className: "fad fa-layer-group", "data-block": block.id, "data-template": block.template_id }) }), _jsx(Button, { "data-tooltip-content": messages.url_settings, "data-tooltip-id": "blockinfo", "data-block": block.id, "data-template": block.template_id, onClick: () => getImageUrlSettings(block.id), variant: "light", children: _jsx("i", { className: "fad fa-link", "data-block": block.id, "data-template": block.template_id }) })] })), block.template &&
                                                                            block.template.includes('data-background=') &&
                                                                            settings.back_colors && (_jsxs(Button, { variant: "light", "data-block": block.id, "data-parent": block.id, className: "toggle_bg", children: [_jsx("i", { className: "fas fa-fill-drip", "data-block": block.id, "data-parent": block.id }), _jsxs(ButtonGroup, { className: "edit-color", size: "sm", vertical: true, children: [settings.target &&
                                                                                            settings.target.back_colors &&
                                                                                            settings.target.back_colors.map((bgColor) => {
                                                                                                const getBackgroundAttr = block.template.match(/(?:data-background=").*?(?=\s*")/gm);
                                                                                                if (getBackgroundAttr &&
                                                                                                    (getBackgroundAttr[0].includes(bgColor.label[0].name) ||
                                                                                                        getBackgroundAttr[0].includes('true'))) {
                                                                                                    return (_jsx(Button, { "data-tooltip-content": messages.editor.change_backgroundcolor, "data-tooltip-id": "blockinfo", "data-block": bgColor.id, "data-parent": block.id, onClick: () => updateBackground(bgColor.label[0].name, block.id), style: { padding: 4 }, variant: "light", children: _jsx("p", { style: {
                                                                                                                width: 20,
                                                                                                                height: 20,
                                                                                                                padding: 0,
                                                                                                                margin: 0,
                                                                                                                background: bgColor.color,
                                                                                                            } }) }));
                                                                                                }
                                                                                                return null;
                                                                                            }), settings.back_colors &&
                                                                                            settings.back_colors.map((bgColor) => {
                                                                                                const getBackgroundAttr = block.template.match(/(?:data-background=").*?(?=\s*")/gm);
                                                                                                if (getBackgroundAttr &&
                                                                                                    (getBackgroundAttr[0].includes(bgColor.label[0].name) ||
                                                                                                        getBackgroundAttr[0].includes('true'))) {
                                                                                                    return (_jsx(Button, { "data-tooltip-content": messages.editor.change_backgroundcolor, "data-tooltip-id": "blockinfo", "data-block": bgColor.id, "data-parent": block.id, onClick: () => updateBackground(bgColor.label[0].name, block.id), style: { padding: 4 }, variant: "light", children: _jsx("p", { style: {
                                                                                                                width: 20,
                                                                                                                height: 20,
                                                                                                                padding: 0,
                                                                                                                margin: 0,
                                                                                                                background: bgColor.color,
                                                                                                            } }) }));
                                                                                                }
                                                                                                return null;
                                                                                            })] })] })), _jsx(Button, { "data-tooltip-content": messages.editor.copy_block, "data-tooltip-id": "blockinfo", disabled: blockCopyDisable ||
                                                                                (!isSubmission &&
                                                                                    !wlAdminUser &&
                                                                                    onlyWhitelabelAdminCanModifyBlocks.includes(block.id)), "data-block": block.id, onClick: copyBlockF, variant: "light", children: _jsx("i", { className: "fas fa-clone", "data-block": block.id }) }), biggerButton, smallerButton, _jsx(Button, { "data-tooltip-content": messages.editor.delete_block, "data-tooltip-id": "blockinfo", disabled: blockDeleteDisable ||
                                                                                (!isSubmission &&
                                                                                    !wlAdminUser &&
                                                                                    onlyWhitelabelAdminCanModifyBlocks.includes(block.id)), "data-block": block.id, "data-space": block.page_space_needed, onClick: blockContainer === block.id
                                                                                ? (e) => {
                                                                                    unsetBlockContainer === null || unsetBlockContainer === void 0 ? void 0 : unsetBlockContainer();
                                                                                    deleteBlock(e);
                                                                                }
                                                                                : (e) => {
                                                                                    deleteBlock(e);
                                                                                }, variant: "light", children: _jsx("i", { className: "fas fa-trash", "data-block": block.id, "data-space": block.page_space_needed }) })] })] }), pasteButton, block.fixed ? null : (_jsx(Button, { "data-tooltip-content": messages.editor.down, "data-tooltip-id": "blockinfo", disabled: blockDownDisable, "data-block": block.id, "data-target": blockDown, onClick: switchBlock, variant: "light", children: _jsx("i", { className: "far fa-angle-down", "data-block": block.id, "data-target": blockDown }) }))] }), getDeviceType && getDeviceType() === 'desktop' && (_jsx(Tooltip, { id: "blockinfo", place: "right" }))] })) : type === 'active' && block.no_options && !block.container ? (_jsxs("div", { className: "block-options", style: styleOptions, children: [_jsxs(ButtonGroup, { vertical: true, size: "sm", children: [block.fixed ? (_jsx(Button, { className: "is-fixed", "data-tooltip-content": messages.editor.block_can_not_move, "data-tooltip-id": "blockinfo", children: _jsx("i", { className: "far fa-lock" }) })) : (_jsx(Button, { "data-tooltip-content": messages.editor.up, "data-tooltip-id": "blockinfo", disabled: blockUpDisable, "data-block": block.id, "data-target": blockUp, onClick: switchBlock, variant: "light", children: _jsx("i", { className: "far fa-angle-up", "data-block": block.id, "data-target": blockUp }) })), _jsxs("div", { className: "toggle-edit btn btn-default", "data-block": block.id, children: [_jsx("i", { className: "fas fa-edit", "data-block": block.id }), _jsxs(ButtonGroup, { className: "edit-block", size: "sm", vertical: true, children: [_jsx(Button, { "data-tooltip-content": messages.editor.reset_block, "data-tooltip-id": "blockinfo", "data-block": block.id, "data-template": block.template_id, onClick: resBlock, children: _jsx("i", { className: "fas fa-retweet", "data-block": block.id, "data-template": block.template_id }) }), block.template && block.template.includes('<img') && (_jsx(Button, { "data-tooltip-content": messages.editor.filter_settings, "data-tooltip-id": "blockinfo", "data-block": block.id, "data-template": block.template_id, onClick: () => getIndexForImage(block.id), children: _jsx("i", { className: "fad fa-layer-group", "data-block": block.id, "data-template": block.template_id }) })), biggerButton, smallerButton] })] }), pasteButton, block.fixed ? null : (_jsx(Button, { "data-tooltip-content": messages.editor.down, "data-tooltip-id": "blockinfo", disabled: blockDownDisable, "data-block": block.id, "data-target": blockDown, onClick: switchBlock, variant: "light", children: _jsx("i", { className: "far fa-angle-down", "data-block": block.id, "data-target": blockDown }) }))] }), getDeviceType && getDeviceType() === 'desktop' && (_jsx(Tooltip, { id: "blockinfo", place: "right" }))] })) : !block.container ? (_jsx("div", { className: "block-options", style: styleOptions, children: _jsx(ButtonGroup, { vertical: true, size: "sm", children: _jsx(Button, { "data-tooltip-content": messages.editor.reset_block, "data-tooltip-id": "blockinfo", "data-block": block.id, "data-template": block.template_id, onClick: resBlock, variant: "light", children: _jsx("i", { className: "fas fa-retweet", "data-block": block.id, "data-template": block.template_id }) }) }) })) : null, type === 'active' && block.no_options && block.container ? (_jsx("div", { className: "block-options", style: styleOptions, children: _jsx(ButtonGroup, { vertical: true, size: "sm", children: block.container ? (blockContainer === block.id ? (_jsx(Button, { className: "select-container", "data-tooltip-content": messages.editor.deselect_element, "data-tooltip-id": "blockinfo", onClick: () => unsetBlockContainer === null || unsetBlockContainer === void 0 ? void 0 : unsetBlockContainer(), variant: "light", children: _jsx("i", { className: "fas fa-layer-minus" }) })) : (_jsx(Button, { className: "select-container", "data-tooltip-content": messages.editor.select_element, "data-tooltip-id": "blockinfo", onClick: () => setBlockContainer === null || setBlockContainer === void 0 ? void 0 : setBlockContainer(block.id), variant: "light", children: _jsx("i", { className: "fas fa-layer-plus" }) }))) : null }) })) : null] }, block.id));
                            }) })), endless && (_jsx("div", { className: "edition-pagination", children: _jsx(Pagination, { count: propsBlocks.length, resPerPage: blocksPerPage, activePage: page, handleSelect: changePage, isDropDown: true }) }))] })] }));
};
const mapStateToProps = (state) => ({ appIntl: state.intl });
export default withRouter(legacyInjectIntl(connect(mapStateToProps)(EditorPage)));
